import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, combineLatest, forkJoin } from 'rxjs';
import { AuthorizeService } from './authorize.service';
import { mergeMap, merge, switchMap, map, take } from 'rxjs/operators';
import { ApiBaseUrl, DocsUrl } from '../app/management/core/constants/common.constants';
import { UserRoles } from './api-authorization.constants';

@Injectable({
  providedIn: 'root'
})
export class AuthorizeInterceptor implements HttpInterceptor {
  constructor(private authorize: AuthorizeService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return forkJoin(this.authorize.getAccessToken(), this.authorize.getUserRole())
      .pipe(
        switchMap(([token, userRole]) => this.processRequestWithToken(token, userRole, req, next))
      );
  }


  // Checks if there is an access_token available in the authorize service
  // and adds it to the request in case it's targeted at the same origin as the
  // single page application.
  private processRequestWithToken(token: string, userRole: string, req: HttpRequest<any>, next: HttpHandler) {
    if (userRole !== UserRoles.LiveAgent && this.authorize.isTokenExpired(token) === true) {
      return this.authorize.refreshAccessToken().pipe(switchMap(user => {
        if (!!token && (this.isSameOriginUrl(req) || this.isApiUrl(req) || this.isDocsUrl(req))) {
          req = req.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`
            }
          });
        }

        return next.handle(req);
      }));
    }
    else {
      if (!!token && (this.isSameOriginUrl(req) || this.isApiUrl(req) || this.isDocsUrl(req))) {
        req = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`
          }
        });
      }

      return next.handle(req);
    }
  }

  private isApiUrl(req: any) {
    if (req.url.startsWith(ApiBaseUrl)) {
      return true;
    }

    return false;
  }

  private isDocsUrl(req: any) {
    if (req.url.startsWith(DocsUrl)) {
      return true;
    }

    return false;
  }

  private isSameOriginUrl(req: any) {
    // It's an absolute url with the same origin.
    if (req.url.startsWith(`${window.location.origin}/`)) {
      return true;
    }

    // It's a protocol relative url with the same origin.
    // For example: //www.example.com/api/Products
    if (req.url.startsWith(`//${window.location.host}/`)) {
      return true;
    }

    // It's a relative url like /api/Products
    if (/^\/[^\/].*/.test(req.url)) {
      return true;
    }

    // It's an absolute or protocol relative url that
    // doesn't have the same origin.
    return false;
  }
}
